module.exports = __webpack_public_path__ + "static/media/sample.b85ae4de.pdf";